import router from '@/router/router'

export const useRouter = () => {
  return router
}

export const useRoute = () => {
  return router.currentRoute
}
export const usePageRoute = () => {
  const getRouter = () => {
    return router
  }
  const getRoute = () => {
    return router.currentRoute
  }
  return {
    getRouter,
    getRoute,
    router
  }
}
